import { render, staticRenderFns } from "./AddResources.vue?vue&type=template&id=195c85b0&"
import script from "./AddResources.vue?vue&type=script&lang=js&"
export * from "./AddResources.vue?vue&type=script&lang=js&"
import style0 from "./AddResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports